import { hydrateRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import * as tracking from 'dibs-tracking';
import serverVars from 'server-vars';

import { IphoneRespLayout } from '../apps/iphone/IphonesRespLayout/IphoneRespLayout';
import { IphoneMobileLayout } from '../apps/iphone/IphonesMobileLayout/IphoneMobileLayout';

initializeDBL().then(() => {
    hydrateRoot(
        document.getElementById('js-root'),
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            {serverVars.get('settings.isMobile') ? <IphoneMobileLayout /> : <IphoneRespLayout />}
        </IntlProvider>
    );

    tracking.trackPageview({
        category: 'promo interaction',
        action: 'app download sms displayed',
        label: 'app landing page',
    });
});
